import { faComments } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useAuth } from '@polvo-labs/react-auth'
import Axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import 'react-confirm-alert/src/react-confirm-alert.css'
import { toast } from 'react-toastify'
import { RoomsContext } from '../../../context/rooms-context'
import { isInRole } from '../../../models/User'
import Button from '../../Button'
import Icon from '../../Icon'
import Loader from '../../Loader'
import Popover from '../../Popover'
import Text from '../../Text'
import { MessageCreate } from '../type'
import Audio from './Audio'
import Document from './Document'
import Geolocation from './Geolocation'
import Image from './Image'
import { Attachment, InputContainer as Container, Status, TextArea } from './styles'


interface Props {
  online: boolean
  submitMessage: (message: MessageCreate) => Promise<any>
  submittingMessage: boolean
  attendantLogic?: boolean
  canUploadFiles?: boolean
}


const NewMessage: React.FC<Props> = ({
  online,
  submitMessage,
  submittingMessage,
  attendantLogic = true,
  canUploadFiles = true,
}) => {
  const [open, setOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [message, setMessage] = useState<MessageCreate>({
    type: 'TEXT',
    content: '',
  })

  const { roomsState } = useContext(RoomsContext);

  const { token, user } = useAuth()

  const handleChange = (message: MessageCreate) => {
    setMessage(message)
    setOpen(false)
  }

  useEffect(() => {
    let mounted = true
    if (mounted)
      setMessage({
        type: 'TEXT',
        content: '',
      })
    return () => { mounted = false }
  }, [roomsState.room?.uuid])

  const attendClick = () => {
    if (roomsState.room !== undefined) {
      setIsLoading(true)
      Axios({
        method: 'PUT',
        url: `${process.env.REACT_APP_API_URL}/chat/rooms/attendant`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          "room_id": roomsState.room.id,
          "user_id": user.id
        },
      }).then(({ data }) => {
        setIsLoading(false)
        // roomsDispatch({ type: 'set_room_attended', payload: data.data.attendant, uuid: data.data.uuid })
      }).catch(() => {
        setIsLoading(false)
        toast.error('Ocorreu um erro ao enviar mensagem')
      })
    }
  }

  const sendMessage = (evt?: any) => {
    evt?.preventDefault()
    if (message.type === 'TEXT' && message.content === '') {
      return
    }

    submitMessage(message).then(() => {
      setMessage({
        type: 'TEXT',
        content: '',
      })
    })
  }

  const showChatControls = () => {
    if ((!isInRole(user, 'admin') || (roomsState.room?.attendant_id || roomsState.room?.attendant)) || !attendantLogic)
      return (
        <Container
          onSubmit={(evt) => { sendMessage(evt) }}
        >
          <Status
            online={online}
          >
            <Text
              tag="span"
              size="hint"
              color="lightGray"
            >
              Seu interlocutor está {online ? 'online' : 'offline'}
            </Text>
          </Status>

          {message.type === 'TEXT' ? (
            <>
              {(canUploadFiles && <Popover
                open={open}
                button={{
                  label: (
                    <Icon
                      name="attachment"
                    />
                  ),
                  backgroundColor: 'transparent',
                  smallPadding: true,
                }}
                position="top-right"
                onChange={open => setOpen(open)}
              >
                <Image
                  onChange={handleChange}
                />
                <Audio
                  onChange={handleChange}
                />
                <Document
                  onChange={handleChange}
                />
                <Geolocation
                  onChange={handleChange}
                />
              </Popover>
              )}
              <TextArea
                placeholder="Escreva sua mensagem"
                value={message.content || ''}
                maxLength={3000}
                // disabled={submittingMessage}
                onChange={event => {
                  const content = event.target.value

                  setMessage({
                    type: 'TEXT',
                    content,
                  })
                }}
                onKeyDown={event => {
                  if (event.key === 'Enter') {
                    event.preventDefault()
                    if (!submittingMessage) {
                      sendMessage()
                    }
                  }
                }}
              ></TextArea>

              <Text
                tag="span"
                size="hint"
                style={{
                  wordBreak: 'normal',
                  height: '39px',
                  marginTop: 'auto'
                }}
              >
                {message.content?.length}/3000
          </Text>
            </>
          ) : (
              <Attachment>
                <Icon
                  name={message.type.toLowerCase()}
                />

                {message.type !== 'GEOLOCATION' ? (
                  <span>Arquivo: {message.upload?.name}</span>
                ) : (
                    <span>
                      Localização
                    </span>
                  )}

                <Button
                  label="x"
                  backgroundColor="transparent"
                  fontColor="red"
                  onClick={() => {
                    setMessage({
                      type: 'TEXT',
                      content: '',
                    })
                  }}
                />
              </Attachment>
            )}

          <Button
            label={(
              <Icon
                name="send"
              />
            )}
            backgroundColor="transparent"
            smallPadding
            type="submit"
            disabled={submittingMessage}
            onClick={sendMessage}
          />

          {submittingMessage && (
            <Loader
              full
            />
          )}
        </Container>
      )
    else
      return (
        <Button
          style={{ margin: '10px' }}
          label={(isLoading ? <Loader imageStyle={{ height: "fit-content" }} delay={0} /> : <FontAwesomeIcon icon={faComments} />)}
          // backgroundColor="transparent"
          smallPadding
          type="submit"
          onClick={attendClick}
          disabled={isLoading}
        />
      )
  }

  return (
    showChatControls()
  )
}

export default NewMessage
